export default {
	orders: {
		loading: "Loading orders...",
		noOrders: "No orders yet",
		states: {
			ordered: "Ordered",
			delivered: "Delivered",
			paid: "Completed",
			inProduction: "In production",
			produced: "In transit",
			invoiced: "Invoice sent",
			cancelled: "Cancelled",
			creditOverdrawn: "Credit limit exceeded",
			unknown: "Unknown",
			dueDateLabel: "Delivery date ex works",
		},
		kommission: {
			placeholder: "You can enter your order reference number here",
			placeholderShort: "Enter …",
			label: "Order reference number",
			yourNumberLabel: "Your order reference number:",
			yourNumberShortLabel: "Your order ref.",
		},
		orderIdLabel: "Blexon order",
		carrierLabel: "Carrier",
		trackingLabel: "Shipment tracking",
		orderConfirmation: {
			downloadTooltip: "Download order confirmation as PDF document",
			label: "Order confirmation",
			fileName: "Order confirmation {orderId}.pdf",
		},
		invoice: {
			downloadTooltip: "Download invoice as PDF document",
			label: "Invoice",
			fileName: "Invoice for order {orderId}.pdf",
		},
		prepayInvoice: {
			downloadTooltip: "Download advance invoice as PDF document",
			label: "Advance invoice",
			fileName: "Advance invoice {invoiceId}.pdf",
		},
		pageTitle: "Order history",
		loadingArchive: "Loading order history …",
		searchPlaceholder: "Search order no., your order ref. or article id …",
		filterAriaLabel: "Filter by type",
		filterAll: "All",
		filterOrders: "Orders",
		filterCredits: "Credit notes",
		noEntriesFound: "No entries found",
		noCreditsYet: "No credit notes yet",
		adjustSearchHint: "Adjust your search or filter.",
		creditPillTooltip:
			"Total of your open credit notes. Automatically offset against your next invoice.",
		availableCredit: "Available credit",
		thumbsTooltip: "Articles in this order",
		articleCountSuffix: "articles",
		detailsButton: "Details",
		orderTypeTag: "Order",
		orderTitle: "Order {number} of {date}",
		certificatesSuffix: " / Certificates",
		creditNote: {
			typeTag: "Credit note",
			unassignedChip: "Not linked to an order",
			stateRefunded: "Refunded",
			stateSettled: "Offset",
			stateOpen: "Open",
			unassignedNote:
				"This credit note is not linked to any order and will be offset against your next invoice.",
			settledNextInvoiceNote: "Will be offset against your next invoice.",
			numberLabel: "Credit note no.",
			dateLabel: "Date",
			referenceLabel: "Reference",
			referenceOrder: "Order {orderId}",
			noReference: "No order",
			settledOnLabel: "Offset against",
			invoiceReference: "Invoice {invoiceId}",
			downloadTooltip: "Download credit note as PDF document",
			downloadButton: "Credit note",
			fileName: "Credit note {creditNoteId}.pdf",
		},
		details: "Details",
		detailsWithCertificates: "Details / Certificates",
		cancellation: {
			inReview: "Cancellation under review",
			show: "Show cancellation",
			completed: "Cancellation completed",
			processing: "Cancellation being processed",
			cancelButton: "Cancel",
			orderCancelledSuccess: "The order was cancelled successfully.",
			orderAlreadyProcessed: "The order has since been processed.",
			cancelFailed: "The order could not be cancelled.",
		},
		changeDeliveryAddress: "Change delivery address",
		changeInvoiceAddress: "Change invoice address",
		loadMore: {
			tooltip: "Loads more orders.",
			button: "Load more",
		},
		confirmCancellationDialog: {
			title: "Confirm cancellation",
			text: "Processing of this order has not yet started.",
			text2: "In this case, cancellation is possible free of charge. However, only the entire order can be cancelled. If needed, the order will have to be placed again.",
			cancelButton: "Cancel",
			confirmButton: "Cancel order",
		},
		messages: {
			kommissionSaved: "Order reference number has been saved.",
			kommissionSaveError: "Order reference number could not be saved.",
		},
	},
	orderDetail: {
		backToOrders: "Order history",
		orderHeading: "Order {orderId}",
		certificatesAvailable: {
			title: "Certificates available",
			subtitle: "Download the 3.1 mill certificates for this order.",
			button: "3.1 certificate · Article {articleId}",
		},
		orderDataTitle: "Order data",
		orderReceivedLabel: "Order received",
		yourOrderNumberShortLabel: "Your order reference number",
		noOrderNumberShort: "not specified",
		expectedDeliveryDateShortLabel: "Expected delivery date (ex works)",
		expectedCompletionShortLabel: "Expected completion",
		trackingLabelShort: "Shipment tracking",
		invoiceAddressCardTitle: "Invoice address",
		positionsCardTitle: "Positions",
		tableShort: {
			posAbbr: "Pos.",
			totalAbbr: "Total ({currency})",
		},
		titleLabel: "Confirmation for order {orderId}",
		orderDateLabel: "Order received:",
		yourOrderNumberLabel: "Your order reference number:",
		noOrderNumber: "not specified (you can adjust this in your order history)",
		expectedDeliveryDateLabel: "Expected delivery date (ex works):",
		trackingEmailInfo:
			"Once the order is completed, you will receive an email with a tracking link.",
		expectedCompletionLabel: "Expected completion:",
		pickupImportantLabel: "Important:",
		pickupEmailInfo:
			"You will receive an email as soon as your order is ready for collection. Collection is only possible after you have received this email.",
		invoiceAddressLabel: "Invoice address:",
		pickupAddressLabel: "Collection address",
		deliveryAddressLabel: "Delivery address",
		pickupAddressName: "Collection",
		priceModel: {
			standard: "(Fast delivery)",
			slow: "(Cost-optimised delivery)",
			express: "(Express delivery)",
		},
		table: {
			position: "Position",
			quantity: "Quantity",
			preview: "Preview",
			description: "Description",
			pricePerUnit: "Price/unit",
			totalPrice: "Total price ({currency})",
		},
		engraving: "Engraving",
		deburring: "Deburring:",
		preCoated: "pre-coated",
		certificateLink: "3.1 certificate",
		vatLabel: "VAT ({rate}%)",
		totalLabel: "Total",
		certificateErrorDialog: {
			title: "Certificate cannot be loaded",
			text: "The certificate cannot currently be loaded. The service appears to be unavailable.",
			text2: "Please contact our helpdesk.",
			closeButton: "Close",
		},
	},
	ticket: {
		tooltip: "Opens the dialog for submitting a complaint about this order.",
		deadlinePassedTooltip: "The deadline for a complaint has passed. Please contact our helpdesk.",
		createButton: "Submit complaint",
		showButton: "Show complaint",
	},
	editTicketPosition: {
		blexonIdLabel: "Blexon Id:",
		materialLabel: "Material:",
		preCoated: "pre-coated",
		engraving: "Engraving",
		introText:
			"To process your complaint quickly and easily, we need some details for each position.",
		complainTypeQuestion: "What type of complaint is this?",
		selectPlaceholder: "Please select",
		uploadPhotosQuestion: "Upload photos that show the complaint as clearly as possible",
		deleteImageTooltip: "Delete image",
		minOneImageHint: "At least one image must be uploaded.",
		affectedPartsQuestion: "How many parts of this position are affected?",
		allButton: "All",
		partsCountLabel: "Number of parts",
		complaintDescriptionQuestion: "What are you complaining about?",
		complaintDescriptionLabel: "Complaint",
		expectationQuestion: "What do you expect from us?",
		expectationLabel: "Expectation",
		messages: {
			requiredField: "Must be provided.",
			enterValue: "Please enter a value",
			minimumOne: "At least 1",
			maximum: "Maximum {max}",
			maxImagesExceeded: "You can upload a maximum of 10 images.",
			imageUploadError:
				"The image cannot be read. Please use an image in jpg, png or gif format. If you have any problems, please contact info@blexon.com.",
		},
	},
	requestCancellation: {
		orderNotFound: "The order could not be found.",
		titleLabel: "Request cancellation for order #{orderId}",
		alreadyProcessedWarning: "Unfortunately, processing of the order has already started.",
		introText:
			"This order is already being processed. However, a cancellation can still be requested.",
		introText2:
			"We will clarify the costs already incurred and contact you by email. You will then decide which items of the order you definitely want to cancel.",
		feeNoticePart1:
			"Even if you decide against the cancellation after the cost clarification, a processing fee of",
		feeNoticePart2: "is due as soon as you request a cancellation.",
		selectArticlesText: "Please select the items to be cancelled:",
		table: {
			position: "Position",
			quantity: "Quantity",
			preview: "Preview",
			description: "Description",
			pricePerUnit: "Price/unit",
			priceTotal: "Total price",
		},
		blexonIdLabel: "Blexon Id:",
		acceptCostsLabel:
			"I accept the flat-rate processing fee of {currency} {fixCost}.-, which is due when requesting the cancellation.",
		forceCancellationLabel:
			"OPTIONAL! I would like to definitely cancel the selected items, regardless of the costs incurred. I confirm that I will bear all cancellation costs for the items and the cancellation flat fee, and that I will forgo the parts.",
		contactInfoText1: "We will inform you about this cancellation at the address",
		contactInfoText2:
			"If you would like to be contacted at a different email address, you can enter it here:",
		altContactEmailLabel: "Alternative email address",
		cancelButton: "Cancel",
		forceCancelButton: "Cancel definitively",
		requestCancelButton: "Request cancellation",
		altContactButton: {
			useStandard: "Use standard contact details",
			useAlternative: "Use alternative contact details",
		},
		messages: {
			fixCostLoadError: "The cancellation flat fee could not be loaded.",
			positionsLoadError: "The order items could not be loaded.",
			cancellationRequested: "The cancellation has been requested.",
			cancellationRequestError: "The cancellation could not be requested.",
			requiredField: "Must be provided.",
			invalidEmail: "Not a valid email.",
		},
	},
	cancellationConfirmation: {
		requestNotFound: "The cancellation request could not be found.",
		alreadyProcessed: "This cancellation request has already been processed.",
		titleLabel: "Confirm cancellation for order #{orderId}",
		introText: "You have requested to cancel certain items of this order.",
		introText2:
			"The costs for the cancellation are listed below per item. You can select the items you want to cancel. The costs will be adjusted accordingly. Items that are not cancelled will continue to be processed normally. The cancellation flat fee for the clarifications already made in connection with the cancellation is due in any case and is included in the costs.",
		table: {
			articleId: "Article Id",
			position: "Position",
			preview: "Preview",
			description: "Description",
			cancellationCost: "Cancellation costs",
		},
		flatFeeLabel: "Cancellation flat fee",
		totalLabel: "Total",
		backButton: "Back",
		doNotCancelButton: "Do not cancel",
		cancelSelectedButton: "Cancel selected items",
		messages: {
			loadCancellationError: "The cancellation data could not be loaded.",
			loadOrderError: "The order data could not be loaded.",
			confirmError: "The cancellation could not be confirmed.",
		},
	},
	choosePosition: {
		introText: "Please select all items that are affected by this complaint.",
		table: {
			position: "Position",
			image: "Image",
			description: "Description",
			quantity: "Quantity",
			unitPrice: "Unit price",
			total: "Total",
		},
		blexonIdLabel: "Blexon Id:",
		materialLabel: "Material:",
		preCoated: "pre-coated",
		engraving: "Engraving",
	},
	createTicket: {
		titleLabel: "Complaint for order {orderId}",
		stepper: {
			choosePositions: "Select items",
			positionAbbrev: "Pos",
			position: "Position",
			contactData: "Contact details",
			confirmation: "Confirmation",
		},
		emailNoticePart1: "We will send you an email to",
		emailNoticePart2: ", as soon as the status of this complaint changes. If we have any questions, we will call you on",
		emailNoticePart3: ".",
		altContactPrompt:
			"If you would like to be contacted differently regarding the processing of this complaint, you can provide alternative contact details:",
		altContactEmailLabel: "Alternative email address",
		altContactPhoneLabel: "Alternative phone number",
		altContactButton: {
			useStandard: "Use standard contact details",
			useAlternative: "Use alternative contact details",
		},
		missingInfoText: "Please complete the missing information to create the ticket.",
		table: {
			position: "Position",
			image: "Image",
			blexonId: "Blexon Id",
			complainedCount: "# Affected",
			name: "Name",
			complaint: "Complaint",
			expectation: "Expectation",
		},
		correspondenceToLabel: "Correspondence to:",
		replacementDelivery: "Replacement delivery",
		backButton: "Back",
		nextButton: "Next",
		finishButton: "Finish",
		ticketBlockedHint:
			"This complaint has already been processed. Please contact info@blexon.com for further assistance.",
		leaveDialog: {
			title: "Data loss warning",
			text: "Changes will be discarded when you leave.",
		},
		messages: {
			requiredField: "Must be provided.",
			invalidEmail: "Not a valid email.",
			saveSuccess: "The complaint was saved successfully.",
			saveError: "Error while saving. Please contact info@blexon.com.",
			orderNotFound: "The ticket cannot be created. Order not found.",
		},
	},
};
